import { Button, CircularProgress, Icon } from '@material-ui/core';
import copy from 'copy-to-clipboard';
import React, { useState } from 'react';

import { ModelPrimaryButton } from '~/src/dash/components/model-primary-button';

export function AsyncButtonOldV2({
  onClick,
  text,
  disabled,
}: {
  onClick: (done: () => void) => void;
  text: React.ReactNode;
  disabled?: boolean;
}) {
  const [updating, setUpdating] = useState(false);
  return (
    <ModelPrimaryButton
      variant='contained'
      color='primary'
      onClick={() => {
        setUpdating(true);
        onClick(() => {
          setUpdating(false);
        });
      }}
      disabled={disabled || updating}
    >
      {text}
      {updating && (
        <CircularProgress
          style={{
            marginLeft: '10px',
          }}
          size={12}
        />
      )}
    </ModelPrimaryButton>
  );
}

export function AsyncButtonV2({
  onClick,
  text,
  disabled,
  inprogress,
  props,
}: {
  disabled?: boolean;
  inprogress?: boolean;
  onClick?: () => void;
  text: React.ReactNode;
  props?: any;
}) {
  return (
    <ModelPrimaryButton
      variant='contained'
      color='primary'
      onClick={onClick}
      disabled={disabled || inprogress}
      {...props}
    >
      {text}
      {!disabled && inprogress && (
        <CircularProgress
          style={{
            marginLeft: '10px',
          }}
          size={12}
        />
      )}
    </ModelPrimaryButton>
  );
}

export function AsyncButton({
  onClick,
  text,
  disabled,
  inprogress,
  props,
}: {
  disabled?: boolean;
  inprogress?: boolean;
  onClick?: () => void;
  text: React.ReactNode;
  props?: any;
}) {
  return (
    <Button
      variant='contained'
      color='primary'
      onClick={onClick}
      disabled={disabled || inprogress}
      {...props}
    >
      {text}
      {!disabled && inprogress && (
        <CircularProgress
          style={{
            marginLeft: '10px',
          }}
          size={12}
        />
      )}
    </Button>
  );
}

export function CopyButton(props: { [key: string]: any; copy: string; text: string }) {
  return (
    <Button
      {...props}
      startIcon={<Icon style={{ fontSize: '1rem', marginLeft: '0.5rem' }}>file_copy</Icon>}
      onClick={() => {
        copy(props.copy);
      }}
    >
      {props.text}
    </Button>
  );
}
